// FELIX™ pending action cards on screen — lets a typed "confirm" / "cancel"
// press the pending card exactly like its button (Law 3 still holds: the
// card's own Confirm runs the write). Cards register with their batch (turn id)
// as the group; only a batch's active card is mounted, so one group = one card.
type PendingCard = { confirm: () => void; cancel: () => void; blocked?: string };
const pending = new Map<string, { card: PendingCard; group: string }>();

export function registerPendingCard(id: string, card: PendingCard, group?: string): () => void {
  const entry = { card, group: group ?? id };
  pending.delete(id);
  pending.set(id, entry);
  return () => { if (pending.get(id) === entry) pending.delete(id); };
}

const CONFIRM = new Set(["confirm", "yes", "y", "do it", "go", "ok", "okay", "approve", "proceed"]);
const CANCEL = new Set(["cancel", "no", "never mind", "nevermind"]);

function word(text: string): string {
  return text.toLowerCase().replace(/[^a-z\s]/g, " ").replace(/\s+/g, " ").trim();
}

/** Returns a local reply when the text was handled, or null to send it to the model. */
export function handleTypedCardWord(text: string): { handled: true; reply?: string } | null {
  const w = word(text);
  const kind = CONFIRM.has(w) ? "confirm" : CANCEL.has(w) ? "cancel" : null;
  if (!kind || pending.size === 0) return null;
  const groups = new Set([...pending.values()].map((e) => e.group));
  if (groups.size > 1) return { handled: true, reply: `Which one? Press ${kind === "confirm" ? "Confirm" : "Cancel"} on the card you mean.` };
  const card = [...pending.values()][0].card;
  if (kind === "confirm") {
    if (card.blocked) return { handled: true, reply: card.blocked };
    card.confirm();
  } else card.cancel();
  return { handled: true };
}
